import { HeadingSection } from 'bold-ui'
import { useEvolucoesOdontoTableQuery } from 'graphql/hooks.generated'
import { EvolucoesOdontoInput } from 'graphql/types.generated'
import React, { useState } from 'react'
import EvolucoesOdontoTable from 'view/atendimentos/detail/soap/plano/evolucoes-odontologicas/historico-evolucoes-odontologicas/EvolucoesOdontoTable'

interface EvolucoesOdontoProps {
  prontuarioId: ID
}

export default function EvolucoesOdonto(props: EvolucoesOdontoProps) {
  const { prontuarioId } = props
  const [state, setState] = useState<EvolucoesOdontoInput>({
    prontuarioId,
    pageParams: {
      size: 5,
    },
  })

  const {
    data: { evolucoesOdonto },
    loading,
  } = useEvolucoesOdontoTableQuery({
    variables: { input: state },
  })

  const onChangeFilter = (filter: EvolucoesOdontoInput) => {
    setState({
      prontuarioId,
      query: filter.query,
      pageParams: {
        ...state.pageParams,
      },
    })
  }

  return evolucoesOdonto?.content?.length > 0 || !!state.query ? (
    <HeadingSection level={3} title='Histórico de evoluções odontológicas'>
      <EvolucoesOdontoTable
        result={evolucoesOdonto}
        loading={loading}
        filterState={state}
        onChange={setState}
        onChangeFilter={onChangeFilter}
      />
    </HeadingSection>
  ) : null
}
